import { render, staticRenderFns } from "./veJkyOrganizeEdit.vue?vue&type=template&id=4f7e2364&scoped=true"
import script from "./veJkyOrganizeEdit.vue?vue&type=script&lang=js"
export * from "./veJkyOrganizeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e2364",
  null
  
)

export default component.exports